<template>
  <span :class="badgeClasses">
    {{ displayState.formatted }}
  </span>
</template>

<script>
import { getSlaDisplayState } from '@/helpers/slaHelper';

var TICK_INTERVAL_MS = 60000;

export default {
  name: 'TicketSlaTimer',
  props: {
    deadlineAt: {
      type: [String, Date],
      default: null
    },
    status: {
      type: Object,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayState: getSlaDisplayState(this.deadlineAt, this.status),
      tickIntervalId: null
    };
  },
  computed: {
    badgeClasses() {
      var classes = ['badge', 'badge-pill', 'ticket-sla-timer'];

      if (this.compact) {
        classes.push('font-size-12');
      } else {
        classes.push('font-size-14');
      }

      if (this.displayState.mode === 'countdown') {
        classes.push('badge-soft-success');
      } else if (this.displayState.mode === 'overdue') {
        classes.push('badge-soft-danger');
      } else {
        classes.push('badge-soft-secondary');
      }

      return classes;
    }
  },
  watch: {
    deadlineAt: function () {
      this.refreshDisplayState();
    },
    status: {
      handler: function () {
        this.refreshDisplayState();
      },
      deep: true
    }
  },
  mounted() {
    this.tickIntervalId = setInterval(this.refreshDisplayState, TICK_INTERVAL_MS);
  },
  beforeDestroy() {
    if (this.tickIntervalId) {
      clearInterval(this.tickIntervalId);
      this.tickIntervalId = null;
    }
  },
  methods: {
    refreshDisplayState() {
      this.displayState = getSlaDisplayState(this.deadlineAt, this.status);
    }
  }
};
</script>

<style lang="scss" scoped>
.ticket-sla-timer {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  padding: 0.4em 0.75em;
  line-height: 1.25;
}
</style>
